import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const gradientWrapper = style({
  borderRadius: vars.radii.l,
  background: vars.colors.blueLilacGradient,
  selectors: {
    '[dir="rtl"] &': {
      background: vars.colors.blueLilacGradientRtl,
    },
  },
});

export const eventSummaryContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  backdropFilter: "blur(10px)",
  borderRadius: vars.radii.l,
  background: vars.colors.glass,
  padding: vars.space.m,
  color: vars.colors.onGlass,
});

export const eventSummaryWrap = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const eventSummaryScores = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  padding: `${vars.space.xs} 0 ${vars.space.m}`,
  width: "100%",
});

export const entryNameStyles = style({
  color: vars.colors.onGlass,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["2xl"],
});

export const playerName = style({
  color: vars.colors.onGlass,
  fontSize: vars.fontSizes.body.l,
});

export const playerNameContainer = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
});

export const buttonContainer = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  gap: vars.space["2xs"],
});

export const glassDivider = style({
  borderTop: vars.colors.glass,
  width: "60%",
});

export const eventSummaryScorePanel = style({
  display: "flex",
  flex: "0 0 30%",
  flexDirection: "column-reverse",
  alignItems: "center",
  fontSize: vars.fontSizes.body.s,
});

export const linkStyles = style({
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "flex-start",
  gap: vars.space.m,
  textDecoration: "none",
  color: vars.colors.onGlass,

  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      justifyContent: "space-between",
      gap: vars.space["2xs"],
    },
  },
});

export const primaryScore = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["6xl"],
});

export const secondaryScore = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["3xl"],
});

export const arrowIconStyles = style({
  transition: "transform 0.2s ease-in-out",
  selectors: {
    [`${linkStyles}:hover &`]: {
      transform: "translateX(2px)",
    },
    '[dir="rtl"] &': {
      transform: "scaleX(-1)",
    },
    [`[dir="rtl"] ${linkStyles}:hover &`]: {
      transform: "scaleX(-1) translateX(2px)",
    },
  },
});

export const eventName = style({
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.m,
});

export const scoreHeaders = style({
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.s,
});

export const eventSummaryIcon = style({
  width: 18,
  height: 18,
  fill: vars.colors.onGlass,
});

export const statusSummaryHeader = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
});
